
<!-- login.component.html -->
<div class="login-container">
  <mat-card class="login-card">
    <mat-card-header class="">
      <mat-card-title>Sign In</mat-card-title>
    </mat-card-header>
    <mat-card-content class="">
      <div class="subtitle" *ngIf="!otpSent">Please enter your registered email address</div>
      <div class="subtitle" *ngIf="otpSent">Enter the 6-digit code sent to your email address</div>
      
      <form [formGroup]="authForm" (ngSubmit)="onSubmit()">
        <!-- Email Field -->
        <mat-form-field appearance="outline" class="full-width" *ngIf="!otpSent">
          <mat-label>Email</mat-label>
          <input matInput placeholder="you@example.com" formControlName="email" type="email" required>
          <mat-error *ngIf="authForm.get('email')?.hasError('required')">
            Email is required
          </mat-error>
          <mat-error *ngIf="authForm.get('email')?.hasError('email')">
            Please enter a valid email
          </mat-error>
        </mat-form-field>

        <!-- OTP Field -->
        <mat-form-field appearance="outline" class="full-width" *ngIf="otpSent">
          <mat-label>6-Digit code</mat-label>
          <input matInput placeholder="123456" formControlName="otp" type="text" maxlength="6" required>
          <mat-error *ngIf="authForm.get('otp')?.hasError('required')">
            Code is required
          </mat-error>
          <mat-error *ngIf="authForm.get('otp')?.hasError('pattern')">
            Code must be 6 digits
          </mat-error>
        </mat-form-field>

        <!-- Auth Buttons -->
        <div class="auth-buttons" *ngIf="!otpSent">
          <button *ngIf="showMagicLink" [disabled]="isRegInProgress || authForm.get('email')?.invalid" 
                  mat-flat-button color="primary" type="button" (click)="sendMagicLink()">
            Send Magic Link
          </button>
          <button *ngIf="showOTP" [disabled]="isRegInProgress || authForm.get('email')?.invalid" 
                  mat-flat-button color="accent" type="button" (click)="sendOTP()">
            Send Code
          </button>
        </div>

        <!-- OTP Verification Buttons -->
        <div class="otp-buttons" *ngIf="otpSent">
          <button [disabled]="isRegInProgress || authForm.get('otp')?.invalid" 
                  mat-flat-button color="primary" type="submit">
            Verify Code
          </button>
          <button mat-stroked-button type="button" (click)="resendOTP()" [disabled]="isRegInProgress">
            Resend Code
          </button>
          <button mat-stroked-button type="button" (click)="goBack()" [disabled]="isRegInProgress">
            Back to Email
          </button>
        </div>
      </form>
    </mat-card-content>
    <mat-card-actions class="justify-content-center">
      <div class="sign-up-link">
        Don't have an account yet? <a routerLink="/register" queryParamsHandling="preserve">Sign up</a>
      </div>
    </mat-card-actions>
  </mat-card>
</div>
